// src/pages/Claim.js

import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useLanguage } from "../context/LanguageContext";
import translations from "../data/translations";

const Claim = () => {
  const navigate = useNavigate();
  const { service, phone, network } = useLocation().state || {};
  const { language } = useLanguage();
  const t = translations[language] || translations["English"];

  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [count, setCount] = useState({ days: 0, hours: 0, mins: 0, secs: 0 });

  // Countdown to a fixed future date
  useEffect(() => {
    const target = new Date("2025-09-01T00:00:00");
    const tick = () => {
      const now = new Date();
      const diff = target - now;
      if (diff <= 0) return;
      setCount({
        days: Math.floor(diff / 86400000),
        hours: Math.floor((diff % 86400000) / 3600000),
        mins: Math.floor((diff % 3600000) / 60000),
        secs: Math.floor((diff % 60000) / 1000),
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  const isRoman = language === "Roman Urdu";

  const copy = {
    badge:        isRoman ? "Jald Aa Raha Hai"         : "Coming Soon",
    // title1:       isRoman ? "Claim karna ho ga"         : "File a Claim,",
    // title2:       isRoman ? "Aur Asaan!"                : "Easier Than Ever!",
    // sub:          isRoman
    //   ? "Hum apna claim feature bilkul naya aur asaan bana rahe hain. Thoda intezar karein — aap ka wait qabil-e-qadr hoga."
    //   : "We're building a seamless claims experience for you. Hang tight — something great is on the way.",
    notifyLabel:  isRoman ? "Notify karo mujhe"         : "Notify Me",
    notifyPlaceholder: isRoman ? "Apna email likhein" : "Enter your email",
    notifyBtn:    isRoman ? "Mujhe Batao"               : "Get Notified",
    successMsg:   isRoman
      ? "Shukriya! Jab claim feature tayar hoga, hum aap ko email karenge."
      : "Thanks! We'll email you as soon as the claim feature is live.",
    backBtn:      isRoman ? "Peechay Jayein"            : "Go Back",
    homeBtn:      isRoman ? "Home Par Jayein"           : "Go to Home",
    featuresTitle: isRoman ? "Kya kuch hoga is feature mein?"  : "What's coming in Claims?",
    features: isRoman
      ? [
          { icon: "📋", title: "Asaan Claim Form",      desc: "Sirf 2 minute mein apna claim submit karein." },
          { icon: "📍", title: "Real-Time Tracking",    desc: "Apne claim ki status live dekhein." },
          { icon: "💸", title: "Tez Refund",            desc: "3–5 din mein refund aap ke account mein." },
          { icon: "🔒", title: "100% Mehfooz",          desc: "Aap ka data bilkul secure hai." },
        ]
      : [
          { icon: "📋", title: "Simple Claim Form",     desc: "Submit your claim in under 2 minutes." },
          { icon: "📍", title: "Real-Time Tracking",    desc: "Track your claim status live." },
          { icon: "💸", title: "Fast Refunds",          desc: "Get your refund within 3–5 working days." },
          { icon: "🔒", title: "100% Secure",           desc: "Your data is always safe with us." },
        ],
    countdownLabel: isRoman
      ? ["Din", "Ghante", "Minute", "Second"]
      : ["Days", "Hours", "Mins", "Secs"],
  };

  return (
    <div className="container-fluid py-4 px-3 px-md-4" style={{ maxWidth: "900px", margin: "0 auto" }}>
      <Header showBack onBack={() => navigate(-1)} />

      <div className="card shadow-sm border-0 rounded-4 p-4 mb-4">

        {/* ── Top badge + icon ── */}
        <div className="text-center mb-4">
          <span style={{
            display: "inline-block",
            background: "linear-gradient(135deg, #0099CC, #00c8f0)",
            color: "#fff", fontWeight: 700,
            fontSize: "0.72rem", letterSpacing: "1.5px",
            padding: "5px 16px", borderRadius: "20px",
            textTransform: "uppercase", marginBottom: "20px"
          }}>
            {copy.badge}
          </span>

          {/* Animated icon */}
          <div style={{ position: "relative", display: "inline-block", margin: "0 auto 20px" }}>
            <div style={{
              width: 100, height: 100, borderRadius: "50%",
              background: "linear-gradient(135deg, #e8f6fb, #c2ecfa)",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: "2.8rem", margin: "0 auto",
              boxShadow: "0 8px 32px rgba(0,153,204,0.18)",
              animation: "pulse 2s infinite"
            }}>
              📋
            </div>
            {/* Orbiting dot */}
            <div style={{
              position: "absolute", top: 6, right: 6,
              width: 20, height: 20, borderRadius: "50%",
              background: "#0099CC",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: "0.6rem", color: "#fff", fontWeight: 700,
              boxShadow: "0 2px 6px rgba(0,153,204,0.4)"
            }}>✨</div>
          </div>

          <h2 style={{ fontWeight: 800, fontSize: "1.6rem", color: "#1a1a2e", marginBottom: "6px", lineHeight: 1.2 }}>
            {copy.title1}{" "}
            <span style={{ color: "#0099CC" }}>{copy.title2}</span>
          </h2>
          <p style={{ fontSize: "0.88rem", color: "#666", lineHeight: 1.7, maxWidth: 500, margin: "0 auto 28px" }}>
            {copy.sub}
          </p>
        </div>

        {/* ── Countdown timer ── */}
        {/* <div className="d-flex justify-content-center gap-3 mb-4 flex-wrap">
          {[
            { val: count.days,  label: copy.countdownLabel[0] },
            { val: count.hours, label: copy.countdownLabel[1] },
            { val: count.mins,  label: copy.countdownLabel[2] },
            { val: count.secs,  label: copy.countdownLabel[3] },
          ].map((item, i) => (
            <div key={i} className="text-center" style={{
              background: "linear-gradient(135deg, #f0faff, #e0f4fc)",
              border: "1.5px solid #b8dff0",
              borderRadius: "14px",
              padding: "14px 20px",
              minWidth: "72px",
            }}>
              <p style={{ fontWeight: 800, fontSize: "1.8rem", color: "#0099CC", marginBottom: "2px", lineHeight: 1 }}>
                {String(item.val).padStart(2, "0")}
              </p>
              <p style={{ fontSize: "0.65rem", color: "#888", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 0 }}>
                {item.label}
              </p>
            </div>
          ))}
        </div> */}

        {/* ── Notify me ── */}
        <div className="mb-4">
          <p style={{ fontWeight: 600, fontSize: "0.85rem", color: "#1a1a2e", marginBottom: "10px", textAlign: "center" }}>
            {copy.notifyLabel}
          </p>

          {!submitted ? (
            <div className="d-flex gap-2">
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder={copy.notifyPlaceholder}
                style={{
                  flex: 1, padding: "11px 14px",
                  border: "1.5px solid #dde", borderRadius: "8px",
                  fontSize: "0.88rem", outline: "none", fontFamily: "inherit"
                }}
                onFocus={e => e.target.style.borderColor = "#0099CC"}
                onBlur={e => e.target.style.borderColor = "#dde"}
              />
              <button
                onClick={() => { if (email.includes("@")) setSubmitted(true); }}
                style={{
                  padding: "11px 20px",
                  background: "#0099CC", color: "white",
                  border: "none", borderRadius: "8px",
                  fontSize: "0.88rem", fontWeight: 700,
                  cursor: "pointer", whiteSpace: "nowrap",
                  transition: "background 0.2s"
                }}
                onMouseEnter={e => e.currentTarget.style.background = "#007aaa"}
                onMouseLeave={e => e.currentTarget.style.background = "#0099CC"}
              >
                {copy.notifyBtn}
              </button>
            </div>
          ) : (
            <div className="d-flex align-items-center gap-2 rounded-3 p-3"
              style={{ background: "#edfaf3", border: "1px solid #b2dfdb" }}>
              <span style={{ fontSize: "1.2rem" }}>✅</span>
              <p style={{ fontSize: "0.82rem", color: "#27ae60", fontWeight: 600, marginBottom: 0 }}>
                {copy.successMsg}
              </p>
            </div>
          )}
        </div>

        {/* Divider */}
        <div style={{ borderTop: "1px solid #f0f0f0", margin: "4px 0 24px" }} />

        {/* ── Features grid ── */}
        <p style={{ fontWeight: 700, fontSize: "0.92rem", color: "#1a1a2e", marginBottom: "16px", textAlign: "center" }}>
          {copy.featuresTitle}
        </p>
        <div className="row g-3 mb-4">
          {copy.features.map((f, i) => (
            <div key={i} className="col-6">
              <div className="rounded-3 p-3 h-100" style={{ background: "#fafcfe", border: "1.5px solid #e6eef3" }}>
                <div style={{ fontSize: "1.5rem", marginBottom: "8px" }}>{f.icon}</div>
                <p style={{ fontWeight: 700, fontSize: "0.82rem", color: "#1a1a2e", marginBottom: "4px" }}>{f.title}</p>
                <p style={{ fontSize: "0.74rem", color: "#888", lineHeight: 1.5, marginBottom: 0 }}>{f.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* ── Service chip (if came from services page) ── */}
        {service && (
          <div className="d-flex align-items-center gap-2 rounded-3 p-3 mb-4"
            style={{ background: "#f0faff", border: "1.5px solid #b8dff0" }}>
            <span style={{ fontSize: "1.4rem" }}>{service.icon}</span>
            <div>
              <p style={{ fontWeight: 700, fontSize: "0.82rem", color: "#1a1a2e", marginBottom: "1px" }}>{service.name}</p>
              <p style={{ fontSize: "0.72rem", color: "#0099CC", marginBottom: 0 }}>
                {isRoman ? "Claim jald available hoga is service ke liye." : "Claim will be available soon for this service."}
              </p>
            </div>
          </div>
        )}

        {/* ── Buttons ── */}
        <button
          onClick={() => navigate(-1)}
          style={{
            width: "100%", padding: "13px",
            background: "white", color: "#0099CC",
            border: "1.5px solid #0099CC", borderRadius: "8px",
            fontSize: "1rem", fontWeight: 600,
            cursor: "pointer", marginBottom: "10px",
            transition: "background 0.2s"
          }}
          onMouseEnter={e => e.currentTarget.style.background = "#e6f5fb"}
          onMouseLeave={e => e.currentTarget.style.background = "white"}
        >
          {copy.backBtn}
        </button>
        <button
          onClick={() => navigate("/")}
          style={{
            width: "100%", padding: "13px",
            background: "#0099CC", color: "white",
            border: "none", borderRadius: "8px",
            fontSize: "1rem", fontWeight: 600,
            cursor: "pointer", transition: "background 0.2s"
          }}
          onMouseEnter={e => e.currentTarget.style.background = "#007aaa"}
          onMouseLeave={e => e.currentTarget.style.background = "#0099CC"}
        >
          {copy.homeBtn}
        </button>
      </div>

      {/* pulse animation */}
      <style>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); box-shadow: 0 8px 32px rgba(0,153,204,0.18); }
          50%       { transform: scale(1.06); box-shadow: 0 12px 40px rgba(0,153,204,0.28); }
        }
      `}</style>

      <Footer />
    </div>
  );
};

export default Claim;